import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/16/solid";

const FormfFirmwareTicket = ({
  formRef,
  handleFirmwareChange,
  handleFirmwareFileChange,
  handleFirmwareSubmit,
  handleFormReset,
  formFirmwareData,
  files,
  getRootProps,
  getInputProps,
  isDragActive,
  handleRecaptchaChange
}) => {
  return (
    <form ref={formRef} name="form2" onSubmit={handleFirmwareSubmit} className="mx-auto max-w-7xl px-4 py-6">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border-0">
          <tbody>
            {/* Client Info Section */}
            <tr>
                <th className="hidden sm:table-cell text-left p-3 align-top text-base font-extrabold w-auto sm:w-[20%]">Client Info</th>
                <td className="text-left p-3">
                  <div className="sm:hidden text-base w-auto font-extrabold mb-4">Client Info</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="sm:col-span-2">
                      <label>Company Name *</label>
                      <input
                        id="companyName"
                        name="companyName"
                        type="text"
                        value={formFirmwareData.companyName}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                    <div>
                      <label>First Name *</label>
                      <input
                        id="firstName"
                        name="firstName"
                        type="text"
                        autoComplete="given-name"
                        value={formFirmwareData.firstName}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                    <div>
                      <label>Last Name *</label>
                      <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        autoComplete="family-name"
                        value={formFirmwareData.lastName}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label>Email *</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        value={formFirmwareData.email}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label>Phone Number *</label>
                      <input
                        id="phone"
                        name="phone"
                        type="text"
                        value={formFirmwareData.phone}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                  </div>
                </td>
            </tr>

            {/* Service Info Section */}
            <tr>
                <th className="hidden sm:table-cell text-left p-3 align-top text-base font-extrabold border-t border-slate-700 w-auto sm:w-[20%]">Firmware Info</th>
                <td className="text-left p-3 border-t border-slate-700">
                  <div className="sm:hidden text-base w-auto font-extrabold mb-4">Firmware Info</div>  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2">
                      <label>Base Firmware Version *</label>
                      <input
                        id="firmwareVersion"
                        name="firmwareVersion"
                        type="text"
                        value={formFirmwareData.firmwareVersion}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label>Description *</label>
                      <textarea
                        id="description"
                        name="description"
                        rows={3}
                        value={formFirmwareData.description}
                        onChange={handleFirmwareChange}
                        required
                        className="block w-full rounded-md bg-black px-3 py-1.5 text-base text-gray-100 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                      />
                    </div>
                    <div>
                      <label>Charger Type</label>
                      <div className="mt-2 grid grid-cols-1">
                        <select
                          id="chargerType"
                          name="chargerType"
                          value={formFirmwareData.chargerType}
                          onChange={handleFirmwareChange}
                          className="col-start-1 row-start-1 w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base bg-black text-gray-100 outline outline-2 -outline-offset-2 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500"
                        >
                            <option value="Artemis">Artemis</option>
                            <option value="Athena">Athena</option>
                            <option value="Neptune">Neptune</option>
                            <option value="Titan 180">Titan 180</option>
                            <option value="Titan 320">Titan 320</option>
                            <option value="Venus">Venus</option>
                            <option value="Other">Other</option>
                        </select>
                        <ChevronDownIcon
                                                aria-hidden="true"
                                                className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                />
                      </div>
                    </div>
                    <div className="sm:col-span-2"></div>
                    <div className='sm:col-span-2'>
                                        <label>Attachment</label>
                                        <div
                                            {...getRootProps()}
                                            className={`mt-2 flex justify-center rounded-lg border border-dashed px-6 py-10 cursor-pointer ${
                                            isDragActive ? "border-blue-500 bg-blue-100" : "border-gray-100"
                                            }`}
                                        >
                                            <div className="text-center">
                                              <DocumentArrowUpIcon aria-hidden="true" className="mx-auto size-12 text-gray-600" />
                                              <div className="mt-4 flex text-sm/6 text-gray-600">
                                                  <label
                                                  htmlFor="file-upload"
                                                  className="relative cursor-pointer rounded-md font-semibold text-gray-300 focus-within:ring-2 focus-within:ring-gray-500 focus-within:ring-offset-2 focus-within:outline-hidden hover:text-gray-500">
                                                  <span>Upload a file</span>
                                                  <input {...getInputProps()} className="sr-only" onChange={handleFirmwareFileChange} />
                                                  </label>
                                                  <p className="pl-1">or drag and drop</p>
                                              </div>
                                              <p className="text-xs/5 text-gray-600">Up to 10MB</p>
                                            </div>
                                        </div>
                                        {/* Preview of uploaded images */}
                                        {files.length > 0 && (
                                            <div className="mt-4">
                                            {files.map((file) => (
                                                <div key={file.name} className="relative">
                                                <img
                                                    src={file.preview}
                                                    alt={file.name}
                                                    className="h-24 object-cover rounded-lg"
                                                    onLoad={() => URL.revokeObjectURL(file.preview)}
                                                />
                                                </div>
                                            ))}
                                            </div>
                                        )}
                                        </div>
                  </div>
                </td>
            </tr>            
            {/* Submit & Reset Section */}
            <tr>
                <th className="hidden sm:table-cell text-left p-3 align-top text-base border-t border-slate-700 w-auto sm:w-[20%]"></th>
                <td className="text-right p-3 pb-20 border-t border-slate-700">
                    <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={handleRecaptchaChange}
                    /><br />
                    <button onClick={handleFormReset} type="reset" className="px-4 py-2 w-full sm:w-auto border border-gray-200 rounded-md text-white bg-black hover:bg-orange-600">
                        Reset
                    </button>
                    &nbsp;
                    <button type="submit" className="px-4 py-2 w-full sm:w-auto border border-transparent rounded-md text-white bg-orange-500 hover:bg-orange-600">
                        Submit
                    </button>
                </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="w-full mx-auto p-6 shadow-lg rounded-lg">
        <h2 className="mb-6 font-extrabold text-lg text-left">Please refer to this table to select the type of custom firmware (or bundle of) requested.</h2>
        <div className="border border-white grid grid-cols-3 gap-0">
            <div className="text-center border border-white p-2">
                <label className="font-extrabold sm:text-xl text-sm">Request Categories</label>
            </div>
            <div className="text-center border border-white p-2">
                <label className="font-extrabold sm:text-xl text-sm">Description & Jurisdiction</label>
            </div>
            <div className="text-center border border-white p-2">
                <label className="font-extrabold sm:text-xl text-sm">Pricing</label>
            </div>
          {[
            ["Main Firmware Update", "Authentication, OCPP, Power Allocation outside standard firmware coverage, custom charging algorithms, load balancing, network connectivity optimizations.", "$200"],
            ["LCD Screen Display Update", "Logo, UI flow, custom display (ads, promotion, etc.), theme customization, font adjustments, multi-language support. AC charger UI does not support video format.", "$150"],
            ["Bug Fix","Minor adjustments (text layout, syntax, ambiguous items), intermittent charging errors, incorrect session reporting, UI glitches, unexpected resets.","$50"],
            ["Feature Enhancement","Improving charging session tracking, adding new analytics, API support for third-party integrations, and user accessibility features.","$100"],
            ["Security Patch","Securing site-specific vulnerabilities, enhancing encryption, and ensuring compliance with tailored security protocols.","$100"],
            ["Communication Protocols","Modifications to OCPP, Modbus, CAN, RS232/RS485 or other communication protocols for charger integration.","$150"],
            ["Performance Optimization","Reducing boot time, improving response speed, better error handling, optimizing memory usage for firmware efficiency.","$50"],
            ["Hardware Compatibility Update","Enabling support for new peripherals (e.g., RFID readers, contactless payment modules), expanding compatibility with different charging cables or power modules.","Consult with TAM"],
            ["Custom Reporting & Logs","Additional logging functionality, real-time status reports, customizable event triggers, enhanced debugging tools.","$100"],
            ["Mobile App Integration","Features that sync charger settings with a mobile app, push notifications, remote diagnostics, user authentication via app.","$150"],
          ].map(([label, description, price]) => (
            <React.Fragment key={label}>
              <div className="text-left border border-white p-2">
                <label className="font-medium">{label}</label>
              </div>
              <div className="text-left border border-white p-2 break-words">
                {description}
              </div>
              <div className="text-left border border-white p-2">
                {price}
              </div>
            </React.Fragment>
            ))}
        </div>
        <h2 className="mt-6 font-extrabold text-lg text-left">Pricing is calculated based on the number of hours evaluated for the scope of work. This is to be communicated and agreed upon with the customer prior to any official development.</h2>
      </div>
    </form>
  );
};

export default FormfFirmwareTicket;
